module.exports = __webpack_public_path__ + "img/appAsset-flag--MX.9fcee7b8.svg";